import { HttpService } from '@Services/index';
import { OnboardingFormFields } from '@Types/index.ts';
import { resolveStateValue } from '@Pages/happyFlowPages/homeAddress/homeAddress.service.ts';
import type { IHomeAddressForm } from '@Types/homeAddress';

interface HomeAddressContext {
  customerId?: string;
  isEmbedded: boolean;
  authorizedUserId?: string;
  authUserCustomerId?: string;
  isAuthUser: boolean;
}

const getHomeAddressUrl = (ctx: HomeAddressContext) => {
  if (ctx.isAuthUser) {
    return `v3/onboarding/user/${ctx.authUserCustomerId}/authorized/user/${ctx.authorizedUserId}/address`;
  } else if (ctx.isEmbedded) {
    return `v3/secureonboarding/partner/user/${ctx.customerId}/address`;
  }
  return `v2/secureonboarding/user/${ctx.customerId}/address`;
};

export const updateCustomerHomeAddress = async (
  payload: IHomeAddressForm,
  ctx: HomeAddressContext
) => {
  const url = getHomeAddressUrl(ctx);
  const { data } = await HttpService.post(url, {
    line1: payload[OnboardingFormFields.LINE1],
    line2: payload[OnboardingFormFields.APARTMENT] || null,
    city: payload[OnboardingFormFields.CITY],
    postalCode: payload[OnboardingFormFields.ZIP],
    state: resolveStateValue(payload),
    country: payload[OnboardingFormFields.COUNTRY]?.code || null,
  });
  return data;
};
